module.exports = __webpack_public_path__ + "media/images/favicon-a7a2470cb4a050011a1e53b9f31442b3.svg";